import React from 'react'
import PropTypes from 'prop-types'
import {
  BUTTON_SIZE,
  CARD_SIZES,
  COLORS,
  CONTAINER_STYLE,
  DIVIDER_SIZE,
  HEADING_TYPE,
  TEXT_SIZES,
} from '@helpers/constants'
import { getSubjectBackgroundClass } from '@helpers/subject'
import Container from '@components/Container'
import SectionCard from '@components/SectionCard'
import Heading from '@components/Heading'
import Text from '@components/Text'
import Divider from '@components/Divider'
import Button from '@components/Button'

const FeaturedSection = (props) => {
  const { heading, text, section, reversed } = props
  const { id, subject } = section
  const bgClass = subject && getSubjectBackgroundClass(subject.slug, 'blockBackground')
  const buttonBgColor =
    subject && getSubjectBackgroundClass(subject.slug, 'dark')

  const wrapperClass = reversed ? 'flex flex-row-reverse' : 'flex flex-row'
  const contentClass = reversed ? 'grow pr-12' : 'grow pl-12'

  return (
    <div className={`w-full py-14 ${bgClass}`}>
      <div className={'max-w-screen-lg mx-auto'}>
        <Container size={CONTAINER_STYLE.DESKTOP} paddingTop={false}>
          <div className={wrapperClass}>
            <div className={'basis-[470px] shrink-0'}>
              <SectionCard
                section={section}
                size={CARD_SIZES.LARGE}
                inLibraryView={false}
              />
            </div>

            <div className={contentClass}>
              {heading && (
                <Heading
                  headingLevel={HEADING_TYPE.H2}
                  size={TEXT_SIZES.XLARGE}
                >
                  {heading}
                </Heading>
              )}
              {text && (
                <div className='max-w-[600px]'>
                  <Text>{text}</Text>
                </div>
              )}

              <Divider size={DIVIDER_SIZE.SMALL} />

              <Button
                backgroundColor={buttonBgColor}
                textColor={COLORS.WHITE.TEXT}
                size={BUTTON_SIZE.LARGE}
                to={`/avsnitt/${id}`}
              >
                Öppna
              </Button>
            </div>
          </div>
        </Container>
      </div>
    </div>
  )
}

FeaturedSection.propTypes = {
  heading: PropTypes.string,
  text: PropTypes.string,
  section: PropTypes.object,
  reversed: PropTypes.bool,
}

export default FeaturedSection
